import React from 'react';
import {
  Button,
  Input,
  Modal,
  ModalProps,
  Row,
  Space,
} from 'antd';

type Props = ModalProps & {
  onConfirmToDoList: Function;
};

const ToDoListInputer = (props: Props) => {
  const { useState } = React;
  const [attrs, setAttrs] = useState<StringKAnyVPair>({});
  const [inited, setInited] = useState(false);
  const [text, setText] = useState('');

  const dialogFooter = () => {
    return (<>
      <Row justify="end">
        <Space>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button
            disabled={!isTextValid()}
            onClick={onConfirm}
            type="primary"
          >
            OK
          </Button>
        </Space>
      </Row>
    </>);
  };

  const isTextValid = () => {
    return text.trim() !== '';
  };

  const onCancel = () => {
    // @ts-ignore
    if (props.onCancel) props.onCancel();
  };

  const onChange = (evt: any) => {
    const t = evt.target.value;

    setText(t.replace(/\t/g, '\n'));
  };

  const onConfirm = () => {
    const list = text.trim().split('\n')
      .map(e => e.trim())
      .filter(e => e !== '');

    if (list.length > 0) {
      props.onConfirmToDoList(list);
      onCancel();
    }
  };

  const onKeyDown = (evt: any) => {
    if (evt.keyCode === 9) {
      const { selectionStart, selectionEnd } = evt.target;
      const textarea = evt.target;
      const newValue = text.substring(0, selectionStart) + 
                       '\n' + 
                       text.substring(selectionEnd);

      setText(newValue);
      // We need to set the cursor position after the state update
      setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd = selectionStart + 1;
      }, 0);
      evt.preventDefault();
    }
  };

  React.useEffect(() => {
    if (!inited) {
      const pa = { ...props };

      setAttrs(pa);
      setInited(true);
    }
  }, [inited, props]);

  return (<>
    <Modal
      {...attrs}
      footer = {dialogFooter()}
      title={props.title || 'To Do List'}
    >
      <Input.TextArea
        autoFocus
        onChange={onChange}
        onKeyDown={onKeyDown}
        rows={15}
        value={text}
      />
    </Modal>
  </>);
};

export default ToDoListInputer;
